const common = {
  // Navbar
  "nav.home": "Home",
  "nav.services": "Services",
  "nav.about": "About Medigreen",
  "nav.contact": "Contact",
  "nav.cta": "Get in Touch",

  // Footer
  "footer.brand.desc": "Expert advisory services for Crude Oil & LNG procurement. Delivering strategic insight and measurable results.",
  "footer.nav.title": "Navigation",
  "footer.contact.title": "Contact",
  "footer.address": "1411 PALE SAN VITORES ROAD, STE 303,\nTAMUNING, GU",
  "footer.phone": "+1.671.482.0104",
  "footer.email": "info@medigreen.energy",
  "footer.copyright": "© 2026 Medigreen LLC. All rights reserved.",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms of Use",

  // Common
  "common.readMore": "Read More",
  "common.viewAll": "View All",
  "common.learnMore": "Learn More",
  "common.contactUs": "Contact Us",
  "common.getStarted": "Get Started",
  "common.freeConsultation": "Free Consultation",
  "common.scheduleConsultation": "Schedule a Free Consultation",
  "common.workWithUs": "Work With Us",
  "common.viewAllNews": "View All News",
  "common.viewAllServices": "View All Services",
  "common.startConversation": "Start a Conversation",
  "common.learnMoreAboutUs": "Learn More About Us",
};

export default common;
